// PRD.275 — Elia AI Assistant Drawer (Phase 1, UI only).
//
// Viewport-driven responsive helpers. `docked` on wide desktop, `overlay` on
// narrow desktop/tablet, `mobile` full-screen (FR-2..FR-4).

import { useEffect, useState } from 'react';
import { resolveEliaLayoutMode, type EliaLayoutMode } from './elia-theme';

function readViewportWidth(): number {
  if (typeof window === 'undefined') return 1280;
  return window.innerWidth;
}

export function useEliaLayoutMode(): EliaLayoutMode {
  const [mode, setMode] = useState<EliaLayoutMode>(() =>
    resolveEliaLayoutMode(readViewportWidth()),
  );

  useEffect(() => {
    const onResize = () => setMode(resolveEliaLayoutMode(readViewportWidth()));
    window.addEventListener('resize', onResize);
    onResize();
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return mode;
}

export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState<boolean>(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  });

  useEffect(() => {
    if (!window.matchMedia) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = () => setReduced(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
